import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export const Loading = () => {
	return (
		<div className='fixed inset-0 z-50 flex items-center justify-center bg-background'>
			<div className='flex flex-col items-center gap-3'>
				<div className='h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent'></div>
				<p className='text-sm text-muted-foreground'>Đang tải...</p>
			</div>
		</div>
	);
};

export const LoadingPanel = () => {
	return (
		<div className='fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm'>
			<div className='flex flex-col items-center gap-3 rounded-xl bg-background p-8 shadow-xl'>
				<div className='h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent'></div>
				<p className='text-sm text-muted-foreground'>Đang xử lý...</p>
			</div>
		</div>
	);
};

export const LoadingTable = () => {
	return (
		<div className='w-full rounded-lg border bg-card p-4'>
			<div className='space-y-4'>
			{Array.from({ length: 8 }).map((_, i) => (
				<div key={i} className='grid grid-cols-5 items-center gap-3'>
					<Skeleton className='h-6 w-12' />
					<Skeleton className='h-6 flex-1' />
					<Skeleton className='h-6 w-32' />
					<Skeleton className='h-6 w-24' />
					<Skeleton className='h-6 w-20' />
				</div>
			))}
			</div>
		</div>
	);
};